import defineComponent from 'flight';
import memberInfo from 'static/script/app/data/member-info';
import WithAjax from 'static/script/app/data/with-ajax';

function CartService() {

    this._addItemToCart = function (evt, payload) {
        this._post({
            url: '/shopping/managecart/additem',
            data: payload,
            success: 'data:cart:after-add-item-to-cart',
            error: 'data:cart:on-add-item-to-cart-error'
        });
    };

    this._removeItemFromCart = function (evt, payload) {
        this._post({
            url: '/shopping/managecart/removeitem',
            data: payload,
            success: 'data:cart:after-item-remove'
        });
    };

    this._removeItemsFromCart = function (evt, payload) {
        this._post({
            url: '/shopping/managecart/removeitems',
            data: payload,
            success: 'data:cart:after-items-remove'
        });
    };

    this._setItemQuantityInCart = function (evt, payload) {
        this._post({
            url: '/shopping/managecart/setitemquantity',
            data: payload,
            success: 'data:cart:after-item-quantity-changed'
        });
    };

    this._getCartSummary = function () {
        this._get({
            url: '/shopping/managecart/summary',
            success: 'data:cart:after-get-summary'
        });
    };

    this._redirectToCartOverview = function (evt, data) {
        this.trigger(document, 'ui:navigate', { href: data.redirectUrl });
    };

    this._startCheckout = function (evt, payload) {
        this._post({
            url: '/shopping/cartoverview/StartCheckoutSession',
            data: payload,
            success: 'data:cart:after-checkout-started'
        });
    };

    this._redirectToCartCheckout = function () {
        this.trigger(document, 'ui:navigate', { href: '/shopping/cartcheckout', withFullPageLoad: true });
    };

    this._setPaymentOption = function (evt, payload) {
        this._post({
            url: '/shopping/cartcheckout/setpaymentoption',
            data: payload,
            success: 'data:cart:after-payment-option-selected'
        });
    };

    this._setShippingOption = function (evt, payload) {
        this._post({
            url: '/shopping/managecart/setshippingoption',
            data: payload,
            success: 'data:cart:after-shipping-option-selected'
        });
    };

    this.after('initialize', function () {
        this.on(document, 'data:cart:after-add-item-to-cart', this._redirectToCartOverview);
        this.on(document, 'data:cart:after-add-item-to-cart', this._getCartSummary);

        this.on(document, 'data:cart:after-item-quantity-changed', this._getCartSummary);
        this.on(document, 'data:cart:after-items-remove', this._getCartSummary);
        this.on(document, 'data:cart:after-item-remove', this._getCartSummary);

        this.on(document, 'ui:cart:on-add-item-to-cart', this._addItemToCart);
        this.on(document, 'ui:cart:on-item-remove', this._removeItemFromCart);
        this.on(document, 'ui:cart:on-items-remove', this._removeItemsFromCart);
        this.on(document, 'ui:cart:on-item-quantity-set', this._setItemQuantityInCart);
        this.on(document, 'ui:cart:on-checkout-start', this._startCheckout);
        this.on(document, 'data:cart:after-checkout-started', this._redirectToCartCheckout);
        this.on(document, 'ui:cart:on-payment-option-select', this._setPaymentOption);
    });
}

export default defineComponent.component(CartService, WithAjax);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/cart-service.js